export class UrlBuilder {
    private readonly baseUrl: string;
    private readonly baseQueryParams: Record<string, string>;

    constructor(baseUrl: string, basePath?: string) {
        const base = this.splitUrl(baseUrl);
        const normalizedBase = this.trimSlashesEnd(base.path);
        const baseQueryParams = { ...base.queryParams };

        if (basePath && basePath.trim().length > 0) {
            const path = this.splitUrl(basePath);
            const normalizedBasePath = this.trimSlashes(path.path);

            this.baseUrl = normalizedBasePath.length > 0
                ? `${normalizedBase}/${normalizedBasePath}`
                : normalizedBase;
            this.baseQueryParams = {
                ...baseQueryParams,
                ...path.queryParams,
            };
            return;
        }

        this.baseUrl = normalizedBase;
        this.baseQueryParams = baseQueryParams;
    }

    public build(
        path?: string | number,
        queryParams?: Record<string, string | number | boolean | null | undefined>
    ): string {
        let url = this.baseUrl;
        const pathQueryParams: Record<string, string> = {};

        if (path !== undefined && path !== null && String(path).trim().length > 0) {
            const pathParts = this.splitUrl(String(path));
            Object.assign(pathQueryParams, pathParts.queryParams);

            if (pathParts.path.trim().length > 0) {
                url += `/${this.trimSlashes(pathParts.path)}`;
            }
        }

        const params = this.paramsToString({
            ...this.baseQueryParams,
            ...pathQueryParams,
            ...queryParams,
        });

        return params ? `${url}${params}` : url;
    }

    private splitUrl(value: string): {
        readonly path: string;
        readonly queryParams: Record<string, string>;
    } {
        const [path, query = ''] = value.split('?');
        const queryParams: Record<string, string> = {};

        if (query.trim().length === 0) {
            return { path, queryParams };
        }

        const params = new URLSearchParams(query);
        params.forEach((paramValue, key) => {
            queryParams[key] = paramValue;
        });

        return { path, queryParams };
    }

    private paramsToString(
        params?: Record<string, string | number | boolean | null | undefined>
    ): string {
        if (!params) {
            return '';
        }

        const entries = Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null);

        if (entries.length === 0) {
            return '';
        }

        const searchParams = new URLSearchParams();
        entries.forEach(([key, value]) => {
            searchParams.set(key, String(value));
        });

        const query = searchParams.toString();
        return query ? `?${query}` : '';
    }

    private trimSlashes(value: string): string {
        return value.replace(/^\/+|\/+$/g, '');
    }

    private trimSlashesEnd(value: string): string {
        return value.replace(/\/+$/g, '');
    }
}
